export default __webpack_public_path__ + "static/media/logoBPayViewHorizontal40.7c990366.svg";